import SiteLayout from '@/components/feature/SiteLayout';
import CtaBanner from '@/components/feature/CtaBanner';
import ServicesHero from './components/ServicesHero';
import ServiceCollection from './components/ServiceCollection';
import ServiceCompare from './components/ServiceCompare';

export default function ServicesPage() {
  return (
    <SiteLayout>
      <title>Home Cleaning Services | CLEARY Recurring, Deep &amp; Move Cleaning</title>
      <meta name="description" content="Explore CLEARY residential cleaning services: recurring home cleaning, deep cleaning and move-in / move-out cleaning, designed thoughtfully around your space." />
      <ServicesHero />
      <ServiceCollection />
      <ServiceCompare />
      <CtaBanner title="Not Sure Where to Start?" text="Tell us about your space and we'll help you explore the right cleaning option." primary={{ label: 'Request a Quote', href: '/contact' }} />
    </SiteLayout>
  );
}